/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

export enum Permission {
    APPLICATION = 'APPLICATION',
    TEMPLATES = 'TEMPLATES',
    GROUPS = 'GROUPS',
    SECURITY = 'SECURITY',
    POLICIES = 'POLICIES',
    WAF = 'WAF',
    ERRORPAGE = 'ERRORPAGE',
    OPERATIONS = 'OPERATIONS',
    INFRASTRUCTURE = 'INFRASTRUCTURE',
    ADMINISTRATION = 'ADMINISTRATION',
    ACCOUNT = 'ACCOUNT',
    GSLB = 'GSLB'
}

export interface IBasicRoleNode {
    name: string;
    permission: string;
    children?: IBasicRoleNode[];
}

export interface IRoleNode {
    name: string;
    permission: string;
    type: string;
    assorted: boolean;
    children: IRoleNode[];
    parentNode: IRoleNode;
    canWrite: boolean;
    canRead: boolean;
    hint: string;
}
